import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import AboutRadio from "@/components/AboutRadio";
import SetsGrid from "@/components/SetsGrid";
import PlaylistSection from "@/components/PlaylistSection";
import EventsList from "@/components/EventsList";
import BlogPreview from "@/components/BlogPreview";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function HomePage() {
  usePageMeta();
  return (
    <>
      <Hero />
      <Marquee />
      <AboutRadio />
      <SetsGrid />
      <PlaylistSection />
      <EventsList />
      <BlogPreview />
      <ContactSection />
      <Footer />
    </>
  );
}
